export default "__VITE_ASSET__B0gE2PYc__"